import React, { useState } from 'react';
import { Calendar, Clock, ArrowRight, User, Tag, ChevronRight, BookOpen, TrendingUp, Shield, Search, Eye, AlertTriangle } from 'lucide-react';

// Blog articles data
const blogArticles = [
  {
    id: 1,
    slug: 'verificare-partener-afaceri-detectiv',
    title: 'Cum Te Poate Ajuta un Detectiv Privat să Verifici Istoricul unui Viitor Partener de Afaceri',
    excerpt: 'Descoperă cum o verificare profesională poate preveni pierderi financiare majore și îți poate proteja afacerea de parteneri cu intenții ascunse.',
    category: 'Business',
    readTime: '8 min',
    date: '2024-12-05',
    featured: true,
    image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800',
    tags: ['verificare afaceri', 'due diligence', 'partener afaceri']
  },
  {
    id: 2,
    slug: '10-semne-partener-relatie-discreta',
    title: '10 Semne Că Partenerul de Viață Are o Relație Discretă',
    excerpt: 'Află care sunt indiciile comportamentale care pot sugera o infidelitate și când este momentul să apelezi la un specialist.',
    category: 'Relații',
    readTime: '6 min',
    date: '2024-12-03',
    featured: true,
    image: 'https://images.unsplash.com/photo-1516585427167-9f4af9627e6c?w=800',
    tags: ['infidelitate', 'verificare fidelitate', 'relații']
  },
  {
    id: 3,
    slug: 'dovezi-acceptate-instanta-detectiv',
    title: 'Ce Dovezi Sunt Acceptate în Instanță de la un Detectiv Particular?',
    excerpt: 'Ghid complet despre tipurile de probe care pot fi folosite legal în proceduri judiciare și cum le obținem conform Legii 329/2003.',
    category: 'Legal',
    readTime: '7 min',
    date: '2024-12-01',
    featured: false,
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800',
    tags: ['dovezi legale', 'instanță', 'probe']
  },
  {
    id: 4,
    slug: 'detectare-camere-microfoane-spion',
    title: 'Cum să Detectezi Camere și Microfoane Spion în Locuință sau Birou',
    excerpt: 'Tehnici profesionale pentru identificarea dispozitivelor de supraveghere ascunse și protejarea confidențialității tale.',
    category: 'Securitate',
    readTime: '5 min',
    date: '2024-11-28',
    featured: true,
    image: 'https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=800',
    tags: ['camere spion', 'microfoane', 'TSCM']
  },
  {
    id: 5,
    slug: 'protectie-fraude-online',
    title: 'Cum să Te Protejezi de Fraudele Online: Ghid Complet 2024',
    excerpt: 'Sfaturi practice pentru identificarea escrocheriilor digitale și ce poți face dacă ai devenit victimă.',
    category: 'Digital',
    readTime: '6 min',
    date: '2024-11-25',
    featured: false,
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800',
    tags: ['fraude online', 'securitate digitală', 'escrocherii']
  },
  {
    id: 6,
    slug: '5-semne-partener-afaceri-suspect',
    title: '5 Semne Că Partenerul Tău de Afaceri Nu Este Cine Spune Că Este',
    excerpt: 'Red flags pe care trebuie să le observi înainte de a investi sau a semna un contract important.',
    category: 'Business',
    readTime: '5 min',
    date: '2024-11-22',
    featured: false,
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800',
    tags: ['due diligence', 'verificare', 'afaceri']
  },
  {
    id: 7,
    slug: 'filaj-supraveghere-legala',
    title: 'Filaj și Supraveghere: Ce Este Legal și Ce Nu în România',
    excerpt: 'Înțelege limitele legale ale supravegherii și de ce este esențial să apelezi la profesioniști licențiați.',
    category: 'Legal',
    readTime: '7 min',
    date: '2024-11-20',
    featured: false,
    image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=800',
    tags: ['filaj', 'supraveghere', 'legal']
  },
  {
    id: 8,
    slug: 'test-poligraf-detector-minciuni',
    title: 'Test Poligraf: Tot Ce Trebuie să Știi despre Detectorul de Minciuni',
    excerpt: 'Cum funcționează testul poligraf, cât de precis este și în ce situații poate fi util pentru tine.',
    category: 'Servicii',
    readTime: '6 min',
    date: '2024-11-18',
    featured: false,
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800',
    tags: ['poligraf', 'detector minciuni', 'teste']
  },
  {
    id: 9,
    slug: 'verificare-angajati-background-check',
    title: 'Background Check pentru Angajați: De Ce Este Esențial pentru Compania Ta',
    excerpt: 'Protejează-ți afacerea prin verificări profesionale ale candidaților înainte de angajare.',
    category: 'Business',
    readTime: '5 min',
    date: '2024-11-15',
    featured: false,
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800',
    tags: ['background check', 'angajați', 'verificare']
  },
  {
    id: 10,
    slug: 'cand-angajezi-detectiv-particular',
    title: 'Când Este Momentul Potrivit să Angajezi un Detectiv Particular?',
    excerpt: 'Situații comune în care serviciile unui detectiv profesionist pot face diferența și îți pot oferi liniștea sufletească.',
    category: 'General',
    readTime: '4 min',
    date: '2024-11-12',
    featured: false,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800',
    tags: ['detectiv particular', 'investigații', 'servicii']
  }
];

// Full article content for featured article
const featuredArticleContent = {
  intro: `În lumea afacerilor, încrederea este fundamentul oricărui parteneriat de succes. Cu toate acestea, istoria recentă ne arată că multe companii au suferit pierderi financiare semnificative din cauza unor parteneri de afaceri care nu erau ceea ce pretindeau a fi. Verificarea atentă a istoricului unui potențial partener nu este doar o măsură de precauție – este o investiție în siguranța și viitorul afacerii tale.`,
  
  sections: [
    {
      title: 'De Ce Este Esențială Verificarea Partenerilor de Afaceri?',
      content: `Conform statisticilor, aproximativ 30% din falimentele companiilor mici și mijlocii sunt cauzate de parteneriate nefericite sau frauduloase. Un detectiv particular licențiat poate efectua verificări comprehensive care depășesc cu mult posibilitățile unei simple căutări pe internet.

Serviciile noastre de verificare sunt prestate în conformitate cu **Legea nr. 329/2003** privind exercitarea profesiei de detectiv particular, ceea ce înseamnă că toate informațiile obținute sunt legale și pot fi utilizate ca probe în instanță, dacă este necesar.`
    },
    {
      title: 'Ce Verificări Poate Efectua un Detectiv Particular?',
      content: `Un detectiv profesionist poate investiga multiple aspecte ale unui potențial partener de afaceri:

• **Verificarea identității reale** – confirmarea că persoana este cine pretinde a fi
• **Istoricul profesional** – verificarea experiențelor anterioare declarate
• **Situația financiară** – analiza solvabilității și a eventualelor datorii
• **Antecedente legale** – verificarea eventualelor litigii sau condamnări
• **Reputația în industrie** – interviuri discrete cu foști parteneri sau angajați
• **Verificarea referințelor** – confirmarea autenticității referințelor prezentate`
    },
    {
      title: 'Semne de Alarmă (Red Flags) la un Potențial Partener',
      redFlags: [
        'Refuză să furnizeze documente oficiale sau le amână constant',
        'Istoricul profesional are "goluri" inexplicabile',
        'Foștii parteneri de afaceri sunt greu de contactat sau refuză să vorbească',
        'Propune scheme de câștig rapid sau promisiuni nerealiste',
        'Presiune pentru a semna rapid, fără timp de analiză',
        'Informațiile din CV nu corespund cu realitatea',
        'Companii anterioare cu probleme financiare sau juridice',
        'Schimbări frecvente de domiciliu sau sediu social',
        'Evită întâlnirile în persoană sau la sediul firmei',
        'Referințe care nu pot fi verificate independent'
      ]
    },
    {
      title: 'Beneficiile Angajării unui Detectiv Profesionist',
      benefits: [
        {
          title: 'Acces la resurse profesionale',
          desc: 'Baze de date specializate și metode de investigație inaccesibile publicului larg'
        },
        {
          title: 'Discreție totală',
          desc: 'Verificările se efectuează fără ca potențialul partener să afle'
        },
        {
          title: 'Rapoarte detaliate',
          desc: 'Documentație completă care poate fi folosită în negocieri sau instanță'
        },
        {
          title: 'Economie de timp și bani',
          desc: 'Prevenirea unei asocieri nefericite costă mult mai puțin decât remedierea consecințelor'
        },
        {
          title: 'Conformitate legală',
          desc: 'Toate metodele respectă legislația în vigoare (Legea 329/2003)'
        }
      ]
    },
    {
      title: 'Procesul de Verificare: La Ce să Te Aștepți',
      content: `Când apelezi la serviciile noastre pentru verificarea unui potențial partener de afaceri, procesul urmează câțiva pași clari:

1. **Consultația inițială gratuită** – discutăm nevoile tale specifice și stabilim obiectivele
2. **Colectarea informațiilor de bază** – primim datele disponibile despre persoana/compania de verificat
3. **Investigația propriu-zisă** – echipa noastră efectuează verificările necesare
4. **Raportul final** – primești un document complet cu toate descoperirile
5. **Consultanță post-investigație** – îți explicăm rezultatele și te sfătuim privind pașii următori`
    }
  ],
  
  conclusion: `Nu lăsa entuziasmul unui parteneriat promițător să îți întunece judecata. O verificare profesională poate face diferența între succesul și eșecul afacerii tale. Cu peste 15 ani de experiență și sute de verificări efectuate, echipa **Detectivi Bacău** îți oferă certitudinea de care ai nevoie pentru a lua decizii informate.`,
  
  cta: `**Ai întrebări despre un potențial partener de afaceri?** Contactează-ne acum pentru o consultație gratuită și confidențială. Sunăm la **+40 725 040 500** sau completează formularul de contact. Confidențialitatea ta este prioritatea noastră.`
};

// Article Card Component
const ArticleCard = ({ article, featured = false }) => {
  if (featured) {
    return (
      <article 
        className="group bg-slate-800/50 border border-slate-700/50 rounded-2xl overflow-hidden hover:border-amber-500/30 transition-all duration-300"
        itemScope
        itemType="https://schema.org/BlogPosting"
      >
        <div className="grid md:grid-cols-2 gap-0">
          <div className="relative h-64 md:h-full overflow-hidden">
            <img 
              src={article.image} 
              alt={`Ilustrație pentru articolul: ${article.title} - Detectivi Bacău blog despre investigații private`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              itemProp="image"
              loading="lazy"
            />
            <div className="absolute top-4 left-4">
              <span className="bg-amber-500 text-slate-900 text-xs font-bold px-3 py-1 rounded-full">
                ARTICOL RECOMANDAT
              </span>
            </div>
          </div>
          <div className="p-6 md:p-8 flex flex-col justify-center">
            <div className="flex items-center gap-4 mb-4">
              <span className="text-amber-400 text-sm font-medium" itemProp="articleSection">{article.category}</span>
              <span className="text-slate-500 text-sm flex items-center gap-1">
                <Clock className="w-4 h-4" aria-hidden="true" />
                {article.readTime}
              </span>
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors" itemProp="headline">
              {article.title}
            </h3>
            <p className="text-slate-400 mb-4 line-clamp-2" itemProp="description">
              {article.excerpt}
            </p>
            <div className="flex items-center justify-between mt-auto">
              <time className="text-slate-500 text-sm" itemProp="datePublished" dateTime={article.date}>
                {new Date(article.date).toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' })}
              </time>
              <span className="text-amber-400 flex items-center gap-1 text-sm font-medium group-hover:gap-2 transition-all">
                Citește mai mult <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </span>
            </div>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article 
      className="group bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden hover:border-amber-500/30 transition-all duration-300"
      itemScope
      itemType="https://schema.org/BlogPosting"
    >
      <div className="relative h-48 overflow-hidden">
        <img 
          src={article.image} 
          alt={`Ilustrație pentru articolul: ${article.title} - Detectivi Bacău`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          itemProp="image"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="bg-slate-900/80 backdrop-blur-sm text-amber-400 text-xs font-medium px-2 py-1 rounded">
            {article.category}
          </span>
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3 text-sm text-slate-500">
          <span className="flex items-center gap-1">
            <Clock className="w-3 h-3" aria-hidden="true" />
            {article.readTime}
          </span>
          <time itemProp="datePublished" dateTime={article.date}>
            {new Date(article.date).toLocaleDateString('ro-RO', { day: 'numeric', month: 'short' })}
          </time>
        </div>
        <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-amber-400 transition-colors line-clamp-2" itemProp="headline">
          {article.title}
        </h3>
        <p className="text-slate-400 text-sm line-clamp-2 mb-4" itemProp="description">
          {article.excerpt}
        </p>
        <span className="text-amber-400 flex items-center gap-1 text-sm font-medium group-hover:gap-2 transition-all">
          Citește <ArrowRight className="w-4 h-4" aria-hidden="true" />
        </span>
      </div>
    </article>
  );
};

// Full Article View Component
const FullArticleView = ({ onBack }) => {
  const article = blogArticles[0];
  
  return (
    <article 
      className="max-w-4xl mx-auto"
      itemScope
      itemType="https://schema.org/BlogPosting"
    >
      {/* Back button */}
      <button 
        onClick={onBack}
        className="flex items-center gap-2 text-slate-400 hover:text-white mb-6 transition-colors"
      >
        <ChevronRight className="w-4 h-4 rotate-180" aria-hidden="true" />
        Înapoi la Blog
      </button>

      {/* Article Header */}
      <header className="mb-8">
        <div className="flex items-center gap-4 mb-4">
          <span className="bg-amber-500/20 text-amber-400 text-sm font-medium px-3 py-1 rounded-full">
            {article.category}
          </span>
          <span className="text-slate-500 text-sm flex items-center gap-1">
            <Clock className="w-4 h-4" aria-hidden="true" />
            {article.readTime} lectură
          </span>
        </div>
        
        <h1 
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight"
          itemProp="headline"
        >
          {article.title}
        </h1>
        
        <p className="text-xl text-slate-300 mb-6" itemProp="description">
          {article.excerpt}
        </p>
        
        <div className="flex items-center gap-6 text-sm text-slate-500 border-b border-slate-700 pb-6">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center">
              <User className="w-5 h-5 text-amber-400" aria-hidden="true" />
            </div>
            <div>
              <span className="text-white block" itemProp="author">Echipa Detectivi Bacău</span>
              <span>Experți în investigații</span>
            </div>
          </div>
          <time itemProp="datePublished" dateTime={article.date}>
            {new Date(article.date).toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' })}
          </time>
        </div>
      </header>

      {/* Featured Image */}
      <figure className="mb-10">
        <img 
          src={article.image}
          alt="Verificarea profesională a partenerilor de afaceri - servicii de due diligence oferite de Detectivi Bacău pentru protecția investițiilor și prevenirea fraudelor"
          className="w-full h-80 object-cover rounded-2xl"
          itemProp="image"
        />
        <figcaption className="text-slate-500 text-sm mt-2 text-center">
          Verificarea partenerilor de afaceri previne pierderi financiare semnificative
        </figcaption>
      </figure>

      {/* Article Content */}
      <div className="prose prose-invert prose-lg max-w-none" itemProp="articleBody">
        {/* Introduction */}
        <p className="text-slate-300 text-lg leading-relaxed mb-8">
          {featuredArticleContent.intro}
        </p>

        {/* Section 1 */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-white mb-4">
            {featuredArticleContent.sections[0].title}
          </h2>
          <div className="text-slate-300 leading-relaxed whitespace-pre-line">
            {featuredArticleContent.sections[0].content}
          </div>
        </section>

        {/* Section 2 - Services */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-white mb-4">
            {featuredArticleContent.sections[1].title}
          </h2>
          <div className="text-slate-300 leading-relaxed whitespace-pre-line">
            {featuredArticleContent.sections[1].content}
          </div>
        </section>

        {/* Section 3 - Red Flags */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-white mb-4">
            {featuredArticleContent.sections[2].title}
          </h2>
          <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-6">
            <div className="flex items-center gap-2 mb-4">
              <AlertTriangle className="w-5 h-5 text-red-400" aria-hidden="true" />
              <span className="text-red-400 font-semibold">Atenție la aceste semnale de alarmă:</span>
            </div>
            <ol className="space-y-3">
              {featuredArticleContent.sections[2].redFlags.map((flag, index) => (
                <li key={index} className="flex items-start gap-3 text-slate-300">
                  <span className="bg-red-500/20 text-red-400 w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                    {index + 1}
                  </span>
                  {flag}
                </li>
              ))}
            </ol>
          </div>
        </section>

        {/* Section 4 - Benefits */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-white mb-4">
            {featuredArticleContent.sections[3].title}
          </h2>
          <div className="grid md:grid-cols-2 gap-4">
            {featuredArticleContent.sections[3].benefits.map((benefit, index) => (
              <div key={index} className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 rounded-lg bg-amber-500/20 flex items-center justify-center">
                    <Shield className="w-4 h-4 text-amber-400" aria-hidden="true" />
                  </div>
                  <h3 className="text-white font-semibold">{benefit.title}</h3>
                </div>
                <p className="text-slate-400 text-sm">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Section 5 - Process */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-white mb-4">
            {featuredArticleContent.sections[4].title}
          </h2>
          <div className="text-slate-300 leading-relaxed whitespace-pre-line">
            {featuredArticleContent.sections[4].content}
          </div>
        </section>

        {/* Conclusion */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-white mb-4">Concluzie</h2>
          <p className="text-slate-300 leading-relaxed">
            {featuredArticleContent.conclusion}
          </p>
        </section>

        {/* CTA Box */}
        <div className="bg-gradient-to-r from-amber-500/20 to-amber-600/20 border border-amber-500/30 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Protejează-ți Afacerea Acum
          </h3>
          <p className="text-slate-300 mb-6 max-w-2xl mx-auto">
            {featuredArticleContent.cta}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+40725040500"
              className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold px-8 py-4 rounded-xl transition-colors inline-flex items-center justify-center gap-2"
            >
              <span>📞</span> Sună: +40 725 040 500
            </a>
            <a 
              href="#contact"
              className="bg-slate-700 hover:bg-slate-600 text-white font-semibold px-8 py-4 rounded-xl transition-colors"
            >
              Completează Formularul
            </a>
          </div>
        </div>
      </div>

      {/* Tags */}
      <footer className="mt-10 pt-6 border-t border-slate-700">
        <div className="flex items-center gap-2 flex-wrap">
          <Tag className="w-4 h-4 text-slate-500" aria-hidden="true" />
          {article.tags.map((tag, index) => (
            <span key={index} className="bg-slate-800 text-slate-400 text-sm px-3 py-1 rounded-full">
              {tag}
            </span>
          ))}
        </div>
      </footer>
    </article>
  );
};

// Main Blog Section Component
const BlogSection = () => {
  const [viewingArticle, setViewingArticle] = useState(false);
  const [activeCategory, setActiveCategory] = useState('Toate');
  
  const categories = ['Toate', 'Business', 'Relații', 'Legal', 'Securitate', 'Digital', 'Servicii'];
  
  const filteredArticles = activeCategory === 'Toate' 
    ? blogArticles 
    : blogArticles.filter(a => a.category === activeCategory);
  
  const featuredArticles = blogArticles.filter(a => a.featured);
  const regularArticles = filteredArticles.filter(a => !a.featured);

  if (viewingArticle) {
    return (
      <section id="blog" className="py-20 bg-slate-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <FullArticleView onBack={() => setViewingArticle(false)} />
        </div>
      </section>
    );
  }

  return (
    <section 
      id="blog" 
      className="py-20 bg-slate-900"
      aria-labelledby="blog-heading"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <header className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-amber-400 font-semibold text-sm uppercase tracking-wider mb-4">
            <BookOpen className="w-4 h-4" aria-hidden="true" />
            Blog Detectivi Bacău
          </span>
          <h2 id="blog-heading" className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Ghiduri și Sfaturi de la Experți în Investigații
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Articole educative despre investigații private, securitate personală și protecția afacerilor. 
            Învață de la profesioniști cu peste 15 ani experiență.
          </p>
        </header>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                activeCategory === category
                  ? 'bg-amber-500 text-slate-900'
                  : 'bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-white'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Featured Articles */}
        {activeCategory === 'Toate' && (
          <div className="mb-10">
            <h3 className="text-lg font-semibold text-white mb-6 flex items-center gap-2">
              <TrendingUp className="w-5 h-5 text-amber-400" aria-hidden="true" />
              Articole Recomandate
            </h3>
            <div className="space-y-6">
              {featuredArticles.slice(0, 1).map((article) => (
                <div key={article.id} onClick={() => setViewingArticle(true)} className="cursor-pointer">
                  <ArticleCard article={article} featured={true} />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* All Articles Grid */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-6 flex items-center gap-2">
            <Search className="w-5 h-5 text-amber-400" aria-hidden="true" />
            {activeCategory === 'Toate' ? 'Toate Articolele' : `Articole: ${activeCategory}`}
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {(activeCategory === 'Toate' ? regularArticles : filteredArticles).map((article) => (
              <div 
                key={article.id} 
                onClick={() => article.id === 1 && setViewingArticle(true)}
                className={article.id === 1 ? 'cursor-pointer' : ''}
              >
                <ArticleCard article={article} />
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-8">
            <h3 className="text-xl font-bold text-white mb-3">
              Ai Nevoie de Ajutor Profesionist?
            </h3>
            <p className="text-slate-400 mb-6 max-w-xl mx-auto">
              Echipa noastră de detectivi particulari licențiați este pregătită să te ajute. 
              Consultația inițială este gratuită și confidențială.
            </p>
            <a 
              href="#contact"
              className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold px-8 py-4 rounded-xl transition-colors"
            >
              Solicită Consultație Gratuită
              <ArrowRight className="w-5 h-5" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
